import styled from 'styled-components'

import theme from '../../styleguide/theme'

export const RightCol = styled.div`
	grid-column: 3;
	place-self: center right;
	display: flex;
	align-items: center;
	gap: ${theme.spacing(2)};
`
